var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickClose.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
          },
          on: { keydown: _vm.onKeydown },
        },
        [
          _c("header", { staticClass: "dialog__header" }, [
            _c(
              "h2",
              { staticClass: "dialog__title", attrs: { id: _vm.titleId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
          ]),
          _c("div", { staticClass: "dialog__body" }, [
            _c("p", { staticClass: "dialog__description" }, [
              _vm._v(_vm._s(_vm.description)),
            ]),
          ]),
          _c("footer", { staticClass: "dialog__footer" }, [
            _c(
              "button",
              {
                ref: "closeButtonRef",
                staticClass: "dialog__close-button",
                attrs: { tabindex: "0", type: "button" },
                on: { click: _vm.onClickClose },
              },
              [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }